import { Component, Input } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeCardHeaderSkeletonComponent } from 'se-fe-card/skeleton'
import { SeFeListModule } from 'se-fe-list'
import { SeFeListItemSkeletonComponent } from 'se-fe-list/skeleton'

const DEFAULT_ROW_COUNT = 2

@Component({
  selector: 'se-po-profile-teams-skeleton',
  standalone: true,
  imports: [
    SeFeCardModule,
    SeFeCardHeaderSkeletonComponent,
    SeFeListModule,
    SeFeListItemSkeletonComponent,
  ],
  templateUrl: './profile-teams-skeleton.component.html',
})
export class ProfileTeamsSkeletonComponent {
  public rows = this.createRows(DEFAULT_ROW_COUNT)

  @Input() public set count(value: number) {
    this.rows = this.createRows(value)
  }

  private createRows(count: number): number[] {
    return Array.from({ length: Math.max(0, Math.floor(count)) })
  }
}
